<template>
  <div v-if="this.getCurrentPage !== '/worktooldetail'">
    <v-layout class="text-xs-right">
      <v-btn  @click="openDialog()" :color="ui.bkgdColor" icon>
        <v-icon :color="ui.btnColor"> source </v-icon>
      </v-btn>
      <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
        <v-card color="wplgrey0">
          <v-card-title :class="ui.textTitle">
            {{defineIDGShortLastSix(selectedTasksItem.basic.idi)}} Procedure
            <v-spacer/>
            {{displayDocumentIDGTypeA(selectedTasksItem.basic.tag, selectedTasksItem.basic.idg)}}
          </v-card-title>
          <v-progress-linear :color="ui.textColor" height="1" value="100">
          </v-progress-linear>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container>
              <v-layout row :class="ui.textSubheadingBold">
                <div class="ml-2">
                  Procedure Step
                </div>
                <v-spacer/>
                <div class="mr-4">
                  {{selectedTasksItem.char.status}}
                </div>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm8>
                  <v-text-field
                  v-model="selectedTasksItem.basic.title"
                  hint="procedure step"
                  prepend-icon="title"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedTasksItem.char.type"
                  hint="type"
                  prepend-icon="work_outline"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedTasksItem.basic.id"
                  hint="step id"
                  prepend-icon="fingerprint"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedTasksItem.char.dis"
                  hint="discipline"
                  prepend-icon="engineering"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedTasksItem.char.theme"
                  hint="theme"
                  prepend-icon="yard"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                  v-model="selectedTasksItem.char.part"
                  hint="parts / tools"
                  prepend-icon="category"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row class="mr-2">
                <v-flex xs12>
                  <v-text-field
                  v-model="selectedTasksItem.char.ref"
                  hint="reference"
                  prepend-icon="note_add"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="mr-2">
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedTasksItem.char.resr"
                  hint="resources"
                  prepend-icon="manage_accounts"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedTasksItem.char.per"
                  hint="persons"
                  prepend-icon="person_add"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm4>
                  <v-text-field
                  v-model="selectedTasksItem.char.hrs"
                  hint="hours"
                  prepend-icon="schedule"
                  suffix="hrs"
                  persistent-hint
                  readonly
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="text-xs-left ml-0 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Description
                </v-chip>
                <v-spacer/>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{selectedTasksItem.char.req}}
                </div>
              </v-layout>
              <v-layout row class="ml-3 mt-3 mr-3">
                <v-spacer/>
                <v-chip :color="ui.chipColor" :class="ui.textSubheading">
                  <v-icon left :color="ui.btnColor">hourglass_empty</v-icon>
                    {{this.calcTaskPersonHours(this.selectedTasksItem.char.per, this.selectedTasksItem.char.hrs)}} phrs
                </v-chip>
              </v-layout>
            </v-container>
            <v-layout row>
              <v-btn @click="closeDialog()" :color="ui.btnColor" flat>
                <v-icon left> exit_to_app </v-icon>
                Close
              </v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import tasksFunctions from "@/data/functions/mixins/tasksFunctions.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import master from "@/data/forms/mixins/master.js";
export default {
  // eslint-disable-next-line
  mixins: [
    dateFunctions,
    apptheme,
    numberFunctions,
    master,
    displayFunctions,
    tasksFunctions
  ],
  computed: {
    ...mapGetters(["getTasksList", "getCurrentPage"]),
    selectedTasksItem() {
      return this.tasks;
    }
  },
  props: {
    tasks: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>
